import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { IPolCoreState, IPOLUserResponse } from '../models/state.model';
import { StorageService } from '../services/storage.service';
import { POLAuthService } from '../services/auth.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  constructor(
    private store: Store<IPolCoreState>,
    private storageService: StorageService,
    private authService: POLAuthService
  ) {}

  user: IPOLUserResponse;
  useAgreement: boolean;

  ngOnInit(): void {
    this.authService.hasUserAgreementData$.asObservable().subscribe((res) => {
      this.user = JSON.parse(this.storageService.getItem('user-profile'));
      this.useAgreement = res.useAgreementVaule || this.user?.useAgreement?.signatureRequired;
    });
  }

  skipToMainContent(event: Event): void {
    event.preventDefault();
    const mainEl: HTMLElement = document.querySelector('#main');
    mainEl.setAttribute('tabindex', '-1');
    mainEl.focus();
  }
}
